import React from 'react';
import PropTypes from 'prop-types';
import { jsx as ___EmotionJSX } from "@emotion/core";
class MultiResolutionBackgroundDiv extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      src: this.props.srcLowResolution || this.props.src
    };
    this.img = null;
  }
  componentDidMount() {
    var img = new Image();
    img.onload = () => {
      this.setState({
        src: this.props.src
      });
    };
    img.src = this.props.src;
    this.img = img;
  }
  componentWillUnmount() {
    if (this.img) {
      this.img.onload = null;
      this.img = null;
    }
  }
  render() {
    var style = {
      backgroundImage: "url(".concat(this.state.src, ")")
    };
    return ___EmotionJSX("div", {
      role: "img",
      className: this.props.className,
      style: style
    }, this.props.children);
  }
}
MultiResolutionBackgroundDiv.propTypes = {
  className: PropTypes.string,
  src: PropTypes.string.isRequired,
  srcLowResolution: PropTypes.string,
  children: PropTypes.node
};
MultiResolutionBackgroundDiv.defaultProps = {
  className: undefined,
  children: [],
  srcLowResolution: null
};
export default MultiResolutionBackgroundDiv;